import { createSlice } from "@reduxjs/toolkit";
import { sortAllView } from "../utils";

const peopleDefaultColumns = [
  "NAME",
  "ROLE",
  "EMAIL",
  "PHONE",
  "PEOPLE STATUS",
  "CREATED BY",
  "CREATE DATE",
];

const bomsDefaultColumns = [
  "BOM NO",
  "TYPE",
  "PRODUCT",
  "PRODUCT NAME",
  "OUTPUT QUANTITY",
  "COST P/UNIT",
  "LABOUR COST",
  "TOTAL COST",
  "INVENTORY CONSUMPTION",
  "STATUS",
  "SUPPLIER",
  "FACILITY",
  "CREATED BY",
  "CREATE DATE",
];

const manufacturingOrderDefaultColumns = [
  "MO NO",
  "PRODUCT",
  "BOM VERSION",
  "STATUS",
  "PRODUCTION QUANTITY",
  "UOM",
  "PLANNED START",
  "REQUIRED BY",
  "EST COMPLETION",
  "FACILITY",
];

const initialState = {
  people: { count: 0, results: [] },
  peopleParams: { limit: 10, offset: 0 },
  peopleSelection: [],
  peopleRoles: [],
  peopleLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: peopleDefaultColumns,
      allViews: { "Default View": peopleDefaultColumns },
      nameOfViews: [],
    },
  },
  boms: { count: 0, results: [] },
  bomsParams: { limit: 10, offset: 0 },
  bomsSelection: [],
  bomsLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: bomsDefaultColumns,
      allViews: { "Default View": bomsDefaultColumns },
      nameOfViews: [],
    },
  },
  manufacturingOrder: { count: 0, results: [] },
  manufacturingOrderParams: { limit: 10, offset: 0 },
  manufacturingOrderSelection: [],
  manufacturingOrderLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: manufacturingOrderDefaultColumns,
      allViews: { "Default View": manufacturingOrderDefaultColumns },
      nameOfViews: [],
    },
  },
  manufacturingOrderData: {},
};

const productionSlice = createSlice({
  name: "production",
  initialState,
  reducers: {
    getPeople: (state, action) => {
      state.people = action.payload;
    },
    getPeopleSelection: (state, action) => {
      state.peopleSelection = action.payload;
    },
    setPeopleParams: (state, action) => {
      state.peopleParams = action.payload;
    },
    updatePeopleParams: (state, action) => {
      state.peopleParams = { ...state.peopleParams, ...action.payload };
    },
    resetPeopleParams: state => {
      state.peopleParams = { limit: state.peopleParams.limit || 10, offset: 0 };
    },
    setPeopleRoles: (state, action) => {
      state.peopleRoles = action.payload;
    },
    setPeopleLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.peopleLayout = {
        ...state.peopleLayout,
        listView: {
          ...state.peopleLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.peopleLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    getBoms: (state, action) => {
      state.boms = action.payload;
    },
    getBomsSelection: (state, action) => {
      state.bomsSelection = action.payload;
    },
    setBomsParams: (state, action) => {
      state.bomsParams = action.payload;
    },
    updateBomsParams: (state, action) => {
      state.bomsParams = { ...state.bomsParams, ...action.payload };
    },
    resetBomsParams: state => {
      state.bomsParams = { limit: state.bomsParams.limit || 10, offset: 0 };
    },
    setBomsLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.bomsLayout = {
        ...state.bomsLayout,
        listView: {
          ...state.bomsLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.bomsLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
    getBomData: (state, action) => {
      state.bomData = action.payload;
    },
    clearBomData: state => {
      state.bomData = {};
    },
    getManufacturingOrderData: (state, action) => {
      state.manufacturingOrderData = action.payload;
    },
    clearManufacturingOrderData: state => {
      state.manufacturingOrderData = {};
    },
    getManufacturingOrder: (state, action) => {
      state.manufacturingOrder = action.payload;
    },
    getManufacturingOrderSelection: (state, action) => {
      state.manufacturingOrderSelection = action.payload;
    },
    setManufacturingOrderParams: (state, action) => {
      state.manufacturingOrderParams = action.payload;
    },
    updateManufacturingOrderParams: (state, action) => {
      state.manufacturingOrderParams = { ...state.manufacturingOrderParams, ...action.payload };
    },
    resetManufacturingOrderParams: state => {
      state.manufacturingOrderParams = {
        limit: state.manufacturingOrderParams.limit || 10,
        offset: 0,
      };
    },
    setManufacturingOrderLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.manufacturingOrderLayout = {
        ...state.manufacturingOrderLayout,
        listView: {
          ...state.manufacturingOrderLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: {
            ...state.manufacturingOrderLayout.listView.allViews,
            ...views.list.allViews,
          },
        },
        completeListOfViews: action.payload,
      };
    },
  },
});

export const {
  getPeople,
  getPeopleSelection,
  setPeopleParams,
  updatePeopleParams,
  resetPeopleParams,
  setPeopleRoles,
  setPeopleLayoutAllViews,
  getBoms,
  getBomsSelection,
  setBomsParams,
  updateBomsParams,
  resetBomsParams,
  setBomsLayoutAllViews,
  getBomData,
  clearBomData,
  getManufacturingOrderData,
  clearManufacturingOrderData,
  getManufacturingOrder,
  getManufacturingOrderSelection,
  setManufacturingOrderParams,
  updateManufacturingOrderParams,
  resetManufacturingOrderParams,
  setManufacturingOrderLayoutAllViews,
} = productionSlice.actions;

export default productionSlice.reducer;
